import type { TranslationDictionary } from "./types";

export const pt: TranslationDictionary = {
  // ── EmailGate ──
  "emailGate.exclusiveProposal": "Proposta Exclusiva",
  "emailGate.yourProposalIsReady": "Sua proposta personalizada está pronta",
  "emailGate.enterEmail": "Insira seu e-mail para acessar",
  "emailGate.placeholder": "seu@email.com",
  "emailGate.invalidEmail": "Por favor, insira um e-mail válido",
  "emailGate.blockedEmail":
    "Por favor, insira um e-mail corporativo ou pessoal válido",
  "emailGate.accessProposal": "Acesse sua proposta exclusiva",
  "emailGate.loading": "Carregando...",
  "emailGate.notFound": "Proposta não encontrada",
  "emailGate.loadError":
    "Não foi possível carregar a proposta. Verifique o link ou tente novamente.",
  "emailGate.retry": "Tentar Novamente",
  "emailGate.socialProof": "+2.000 empresas confiam na Woba",
  "emailGate.footer": "Powered by Woba",
  "emailGate.proposalLoadError": "Erro ao carregar proposta. Tente novamente.",

  // ── ProposalContent ──
  "proposal.notFoundOrExpired": "Proposta não encontrada ou expirada.",

  // ── HeroSection ──
  "hero.preparedFor": "Preparado para {{companyName}}",
  "hero.titleWithCity": "Seu escritório em {{city}}, pronto para operar.",
  "hero.titleNoCity": "Seu escritório, pronto para operar.",
  "hero.optionSingular": "opção selecionada",
  "hero.optionPlural": "opções selecionadas",
  "hero.allInclusive": "· Tudo incluso · Um único contrato.",
  "hero.spaceSingular": "{{count}} espaço selecionado",
  "hero.spacePlural": "{{count}} espaços selecionados",
  "hero.readyInCity": "Prontos para operar em {{city}}",
  "hero.readyToOperate": "Prontos para operar",
  "hero.singleContract": "Um único contrato",
  "hero.singleContractDesc": "Para todos os espaços da empresa",
  "hero.centralizedManagement": "Gestão centralizada",
  "hero.centralizedManagementDesc": "Sem burocracia, sem surpresas",
  "hero.bestPrice": "Melhor preço garantido",
  "hero.bestPriceDesc": "Paridade de preço com contratação direta",
  "hero.startingFrom": "A partir de",
  "hero.perPositionMonth": "/posição/mês",
  "hero.viewSpaces": "Ver espaços",
  "hero.pricesGuaranteedUntil": "Preços garantidos até {{date}}",
  "hero.contractTermLabel": "Prazo do contrato",
  "hero.contractTerm.6": "6 meses",
  "hero.contractTerm.12": "12 meses",
  "hero.contractTerm.24": "24 meses",
  "hero.contractTerm.36": "36 meses",

  // ── Chat ──
  "chat.contextLabel": "Tirando dúvidas sobre",
  "chat.placeholder": "Pergunte sobre este espaço...",
  "chat.welcomeLine1":
    "Olá! 👋 Estou aqui para tirar suas dúvidas sobre o **{{spaceName}}**.",
  "chat.welcomeDetailsPrefix": "Esse espaço fica",
  "chat.welcomeAt": "em {{address}}",
  "chat.welcomeCapacity": "com capacidade para **{{capacity}} posições**",
  "chat.welcomePrice": "a **R$ {{price}}/posição/mês**",
  "chat.welcomeAskAnything":
    "Pergunte o que quiser — ou clique nas sugestões abaixo!",
  "chat.errorMessage":
    "Desculpe, ocorreu um erro ao processar sua mensagem. Tente novamente.",
  "chat.dividerNowAbout": "Agora sobre: {{spaceName}}",
  "chat.sendAriaLabel": "Enviar",
  "chat.chip.monthlyValue": "Qual o valor mensal?",
  "chat.chip.parking": "Tem estacionamento?",
  "chat.chip.internet": "Qual a velocidade da internet?",
  "chat.chip.meetingRooms": "Salas de reunião inclusas?",
  "chat.chip.credits": "Como funcionam os créditos Woba?",
  "chat.chip.contract": "Qual a flexibilidade do contrato?",
  "chat.chip.scheduleVisit": "Quero agendar uma visita",

  // ── SpacesSection ──
  "spaces.selectedSpaces": "Espaços Selecionados",
  "spaces.optionsFor": "Opções para {{companyName}}",
  "spaces.optionsForDefault": "Opções para sua empresa",
  "spaces.bestOfficesInCity":
    "Selecionamos os melhores escritórios em {{city}} para a sua operação",
  "spaces.bestOptions": "Selecionamos as melhores opções para a sua operação",
  "spaces.availableOptions": "Opções Disponíveis",
  "spaces.recommended": "★ Recomendado",
  "spaces.combo": "Conjunto",
  "spaces.pos": "pos",
  "spaces.tabPhotos": "Fotos",
  "spaces.tabMap": "Mapa",
  "spaces.tabAmenities": "Amenidades",
  "spaces.tabChat": "Dúvidas",
  "spaces.scopeOffice": "Escritório Privativo",
  "spaces.scopeSpace": "Espaço",
  "spaces.tabNavLabel": "Navegação do espaço",
  "spaces.fullscreenTitle": "Localização dos Espaços",

  // ── PhotosTab ──
  "photos.noImage": "Sem imagem disponível",
  "photos.didYouLike": "Gostou?",
  "photos.liked": "Gostei",
  "photos.disliked": "Não gostei",
  "photos.positions": "posições",
  "photos.perMonth": "/mês",
  "photos.costRent": "Aluguel + Condomínio + IPTU 53%",
  "photos.costServices": "Serviços 32%",
  "photos.costSupport": "Suporte 15%",
  "photos.perPosition": "R$ {{price}} por posição",
  "photos.priceOnRequest": "Valor sob consulta",
  "photos.licenseFee": "License Fee R$ {{price}}",
  "photos.licenseFeeIncluded": "License Fee incluso",

  // ── AmenitiesTab ──
  "amenities.notAvailable": "Informações de amenidades não disponíveis.",

  // ── MapTab ──
  "map.coworkings": "Coworkings",
  "map.fullscreen": "Tela cheia",
  "map.fullscreenAriaLabel": "Ver mapa em tela cheia",
  "map.calculateDistance": "Calcular distância a partir de...",
  "map.placeholder": "Ex: Av. Paulista, 1000",
  "map.searching": "Buscando...",
  "map.calculate": "Calcular",
  "map.distancesFrom": "Distâncias a partir de",
  "map.addressNotProvided": "Endereço não informado",
  "map.selectedNoAddress": "Endereço não informado para esta opção",
  "map.recenter": "Recentralizar",
  "map.recenterTitle": "Recentralizar mapa",
  "poi.noDescription": "Sem descrição",

  // ── ComparisonSection ──
  "comparison.heading":
    "A forma mais inteligente de contratar e administrar escritórios.",
  "comparison.subheadingPre":
    "Abandone as complexidades do modelo tradicional e",
  "comparison.subheadingBold":
    "centralize tudo em um único contrato inteligente",
  "comparison.subheadingPost": "— mude para o modelo Woba e descubra.",
  "comparison.tabTraditional": "Locação tradicional",
  "comparison.tabWoba": "Woba",
  "comparison.traditional.title": "Os custos que você esquece de somar.",
  "comparison.traditional.desc":
    "Porque no modelo tradicional, o valor do aluguel é só o começo.",
  "comparison.woba.title": "Um valor único, sem surpresas",
  "comparison.woba.desc":
    "Com o modelo Woba, você tem um valor único, sem surpresas — do aluguel à limpeza.",

  // ── SpaceComparisonTable ──
  "table.badge": "Comparativo",
  "table.heading": "Comparativo por Espaço",
  "table.subheading": "Todas as opções lado a lado para facilitar sua decisão",
  "table.colSpace": "Espaço",
  "table.colLocation": "Localização",
  "table.colPositions": "Posições",
  "table.colArea": "Área",
  "table.colPricePerPosition": "R$/Posição",
  "table.colCreditsPerPosition": "Créditos/Posição",
  "table.colMonthly": "Mensalidade",
  "table.colCreditsMonth": "Créditos/Mês",
  "table.colLicenseFee": "License Fee",
  "table.licenseFeeTooltip": "Valor pago somente uma vez",
  "table.colVisit": "Visitar",
  "table.included": "Incluso",
  "table.belowMarket": "▼ {{pct}}% abaixo do mercado",
  "table.wantToVisit": "Quero visitar",
  "table.selected": "Selecionado",
  "table.sent": "Enviado",
  "table.bestPriceGuarantee": "Garantia de melhor preço",
  "table.bestPriceDesc": "— Mesmo valor da contratação direta.",
  "table.marketSource":
    "Comparado com a média de mercado da região. Fonte: base Woba.",
  "table.credits": "Créditos",
  "table.visitBarSingular": "espaço selecionado para visita",
  "table.visitBarPlural": "espaços selecionados para visita",
  "table.scheduleVisits": "Agendar visitas",

  // ── BeforeAfterSection ──
  "beforeAfter.badge": "Antes vs Depois",
  "beforeAfter.heading": "Modelo tradicional vs. Woba",
  "beforeAfter.subheading": "Menos etapas, menos custo, mais controle.",
  "beforeAfter.traditional": "Tradicional",
  "beforeAfter.withWoba": "Com Woba",
  "beforeAfter.trad.suppliers": "13",
  "beforeAfter.trad.suppliersDesc": "fornecedores diferentes",
  "beforeAfter.trad.timeline": "3–6",
  "beforeAfter.trad.timelineDesc": "para implementar a operação",
  "beforeAfter.trad.timelineSuffix": "meses",
  "beforeAfter.trad.variableCosts": "Custos variáveis",
  "beforeAfter.trad.variableCostsDesc": "surpresas diferentes a cada mês",
  "beforeAfter.trad.closedContract": "Contrato fechado",
  "beforeAfter.trad.closedContractDesc": "multas de 3 a 6 meses por rescisão",
  "beforeAfter.trad.noVisibility": "Sem visibilidade",
  "beforeAfter.trad.noVisibilityDesc":
    "dados espalhados em vários fornecedores",
  "beforeAfter.trad.blindDecision": "Decisão no escuro",
  "beforeAfter.trad.blindDecisionDesc": "sem dados para otimizar custos",
  "beforeAfter.woba.singleContract": "1",
  "beforeAfter.woba.singleContractDesc": "contrato único, tudo incluso",
  "beforeAfter.woba.timeline": "15",
  "beforeAfter.woba.timelineDesc": "operando com onboarding completo",
  "beforeAfter.woba.timelineSuffix": "dias",
  "beforeAfter.woba.fixedValue": "Valor fixo mensal",
  "beforeAfter.woba.fixedValueDesc": "sem surpresas, sem custos ocultos",
  "beforeAfter.woba.onDemand": "Monte sob demanda",
  "beforeAfter.woba.onDemandDesc": "expanda, reduza ou troque sem multa",
  "beforeAfter.woba.dashboard": "Dashboard em tempo real",
  "beforeAfter.woba.dashboardDesc": "ocupação, custos e uso num só lugar",
  "beforeAfter.woba.ai": "IA que otimiza operação",
  "beforeAfter.woba.aiDesc": "identifica desperdício e sugere ajustes",
  "beforeAfter.woba.bestPrice": "Melhor preço garantido",
  "beforeAfter.woba.bestPriceDesc":
    "mesmo valor que contratação direta — com toda a plataforma inclusa",
  "beforeAfter.accordionLabel":
    "Ver detalhamento dos 13 custos que você elimina",
  "beforeAfter.accordionIntro":
    "O que você precisaria gerenciar separadamente:",
  "beforeAfter.accordionCat1": "Aluguel + Condomínio + IPTU (48-58%)",
  "beforeAfter.accordionCat1.rent": "Aluguel base",
  "beforeAfter.accordionCat1.condo": "Condomínio",
  "beforeAfter.accordionCat1.tax": "IPTU",
  "beforeAfter.accordionCat2": "Serviços operacionais (28-35%)",
  "beforeAfter.accordionCat2.energy": "Energia",
  "beforeAfter.accordionCat2.staff": "Staff operacional",
  "beforeAfter.accordionCat2.cleaning": "Limpeza",
  "beforeAfter.accordionCat2.internet": "Internet / Telecom",
  "beforeAfter.accordionCat2.maintenance": "Manutenção",
  "beforeAfter.accordionCat2.water": "Água",
  "beforeAfter.accordionCat3": "Suporte e depreciação (12-18%)",
  "beforeAfter.accordionCat3.furniture": "Mobiliário (depreciação)",
  "beforeAfter.accordionCat3.coffee": "Café / Amenities",
  "beforeAfter.accordionCat3.insurance": "Seguros",
  "beforeAfter.accordionCat3.admin": "Admin / Overhead",
  "beforeAfter.accordionSummaryBold1": "13 itens",
  "beforeAfter.accordionSummaryMiddle":
    "para gerenciar, 13 fornecedores, 13 contratos.",
  "beforeAfter.accordionSummaryBold2": "Com Woba, tudo em 1.",

  // ── NetworkSection ──
  "network.badge": "Rede Woba",
  "network.heading": "Você contrata um escritório.\nLeva um país inteiro.",
  "network.subheading":
    "Ao contratar pela Woba, sua equipe não fica presa a um endereço. Com os créditos inclusos no plano, ela pode usar salas de reunião, estações de trabalho e espaços de evento em qualquer cidade do Brasil.",
  "network.stat.flexibleOffices": "escritórios flexíveis",
  "network.stat.meetingRooms": "salas de reunião",
  "network.stat.eventSpaces": "espaços de eventos",
  "network.stat.cities": "cidades na América Latina",
  "network.type.workstations": "Estações de Trabalho",
  "network.type.workstationsDescPre": "1 diária em qualquer uma das",
  "network.type.workstationsDescCount": "+23.000",
  "network.type.workstationsDescPost": "estações",
  "network.type.meetingRooms": "Salas de Reunião",
  "network.type.meetingRoomsDescPre": "1 hora em qualquer uma das",
  "network.type.meetingRoomsDescCount": "+4.200",
  "network.type.meetingRoomsDescPost": "salas",
  "network.type.eventSpaces": "Espaços de Eventos",
  "network.type.eventSpacesDescPre": "1 diária em qualquer um dos",
  "network.type.eventSpacesDescCount": "+1.000",
  "network.type.eventSpacesDescPost": "espaços",
  "network.type.privateOffices": "Escritórios Privativos",
  "network.type.privateOfficesDescPre": "1 mês em qualquer um dos",
  "network.type.privateOfficesDescCount": "+5.200",
  "network.type.privateOfficesDescPost": "escritórios",
  "network.credits": "créditos",
  "network.creditsPerPerson": "créditos/pessoa",
  "network.creditsPerPosition": "créditos/posição",

  // ── FlexibilitySection ──
  "flexibility.title": "Sua operação muda. Seu contrato acompanha.",
  "flexibility.desc":
    "Precisa de mais posições? A gente expande. Precisa reduzir? Renegocia sem multa abusiva. Quer mudar de endereço? Fazemos a migração.",

  // ── NextStepsSection ──
  "nextSteps.heading": "Próximos Passos",
  "nextSteps.subheading": "Do interesse à operação em poucos dias",
  "nextSteps.step1.title": "Agende uma visita",
  "nextSteps.step1.desc": "Conheça o espaço ao vivo",
  "nextSteps.step1.timing": "Hoje",
  "nextSteps.step2.title": "Proposta final",
  "nextSteps.step2.desc": "Valores, condições e SLA",
  "nextSteps.step2.timing": "48h após visita",
  "nextSteps.step3.title": "Assine e ocupe",
  "nextSteps.step3.desc": "Contrato digital, mudança coordenada pela Woba",
  "nextSteps.step3.timing": "Até 15 dias",
  "nextSteps.scheduleVisits": "Agendar visitas",
  "nextSteps.seeSpaces": "Veja os espaços selecionados e agende sua visita.",
  "nextSteps.consultantQuestion":
    "Ainda tem alguma dúvida? Fale com nossa especialista",
  "nextSteps.consultantRole": "Consultora Woba",

  // ── CTASection / Footer ──
  "cta.tagline":
    "A forma mais inteligente de contratar e administrar escritórios",
  "cta.contact": "Contato",
  "cta.proposal": "Proposta",
  "cta.generatedOn": "Gerada em:",
  "cta.validUntil": "Válida até:",
  "cta.validTBD": "A definir",
  "cta.copyright": "© {{year}} Woba. Todos os direitos reservados.",
  "cta.pricesGuaranteedUntil": "Preços garantidos até",
  "cta.afterDate":
    "Após essa data, valores reajustados conforme disponibilidade",
  "cta.scheduleVisits": "Agendar visitas",
  "cta.chooseSpaces": "Escolher espaços para visitar",
  "cta.scheduleVisitsCount": "Agendar visita em {{count}} local",
  "cta.scheduleVisitsCountPlural": "Agendar visita em {{count}} locais",

  // ── LogosSection ──
  "logos.socialProof": "Algumas das milhares de empresas que confiam na Woba",

  // ── FlexCreditsSection ──
  "flexCredits.label": "Créditos Flexíveis Extras",
  "flexCredits.perMonth": "créditos/mês",
  "flexCredits.learnMore": "Saiba mais",

  // ── ScheduleModal ──
  "schedule.title": "Agendar Visitas",
  "schedule.subtitle": "Escolha a data e horário para cada espaço",
  "schedule.availableUntil": "Agendamentos disponíveis até",
  "schedule.chooseDate": "Escolha a data",
  "schedule.chooseTime": "Escolha o horário",
  "schedule.confirm": "Confirmar agendamento",
  "schedule.sending": "Enviando...",
  "schedule.sentLabel": "Agendamento enviado —",
  "schedule.at": "às",
  "schedule.successTitle": "Solicitação enviada!",
  "schedule.successSubtitle": "Suas visitas foram solicitadas",
  "schedule.successNotice":
    "Os horários ainda dependem de confirmação do espaço. Entraremos em contato em breve.",
  "schedule.understood": "Entendido",

  // ── Spaces (additional) ──
  "spaces.option": "Opção {{number}}",
  "spaces.ofTotal": "de {{total}}",

  // ── POI Categories ──
  "poi.restaurant": "Restaurantes",
  "poi.cafe": "Cafés",
  "poi.pharmacy": "Farmácias",
  "poi.transport": "Transporte",
  "poi.hotel": "Hotéis",
  "poi.parking": "Estacionamentos",

  // ── Chat (additional) ──
  "chat.defaultSpaceName": "este espaço",

  // ── FlexCredits (additional) ──
  "flexCredits.estimatedValue": "R$ {{value}}/mês",

  // ── LicenseFee ──
  "licenseFee.title": "License Fee",
  "licenseFee.paidSemiannually": "pago semestralmente",
  "licenseFee.paidAnnually": "pago anualmente",
  "setupFee.title": "Setup Fee",
  "setupFee.paidOnce": "pago uma única vez",
};
